import { useCallback, useEffect, useRef } from 'react';

export const useFetchOnListEnd = (fetchNext: CallableFunction) => {
  const observer = useRef<IntersectionObserver | null>(null);
  const fetchNextRef = useRef(fetchNext);

  useEffect(() => {
    fetchNextRef.current = fetchNext;
  }, [fetchNext]);

  useEffect(() => {
    return () => {
      observer.current?.disconnect();
    };
  }, []);

  const lastItemRef = useCallback((node: HTMLElement | null) => {
    if (observer.current) {
      observer.current.disconnect();
    }

    if (!node || typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return;
    }

    observer.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          fetchNextRef.current();
        }
      },
      {
        rootMargin: '240px 0px',
      },
    );

    observer.current.observe(node);
  }, []);

  return { lastItemRef };
};
